/* eslint-disable import/prefer-default-export */
export function debounce (callback, time) {
	let interval
	return (...args) => {
		clearTimeout(interval)
		interval = setTimeout(() => {
			interval = null
			// eslint-disable-next-line
      callback(...args)
		}, time)
	}
}

/*
* Formats number to be displayed in number of thousands, millions or billions
*
* based on:
* https://stackoverflow.com/questions/12900332/how-do-i-round-millions-and-thousands-in-javascript
*/

/*
****** NOTES: ******
- 1230 returns as 1K instead of 1.23K
*/
export function formatNumber (num) {
	// Nine Zeroes for Billions
	// eslint-disable-next-line no-nested-ternary
	return Math.abs(num) >= 1.0e+9
		? `${Math.round(num / 1.0e+9)  }B`
	// Six Zeroes for Millions
		// eslint-disable-next-line no-nested-ternary
		: Math.abs(num) >= 1.0e+6
			? `${Math.round(num / 1.0e+6)  }M`
		// Three Zeroes for Thousands
			: Math.abs(num) >= 1.0e+3
				? `${Math.round(num / 1.0e+3)  }K`
				: Math.abs(num);
}
